import { makeStyles } from '@material-ui/core/styles';
import theme from '../../theme';

const useStyleLogin = makeStyles({
    root: {
        minWidth: 275,
        margin: 'auto',
        backgroundColor: theme.palette.primary.main,
        textAlign: 'center',
    },
    title: {
        fontSize: '1.5em',
        color: '#fff',
    },
    actionsButton: {
        margin: 'auto',
        fontSize: '1.3em',
    },
    pos: {
        marginBottom: 12,
    },
});

export default useStyleLogin;